import { z } from 'zod'
import { api } from '@/lib/api'
import { newIdempotencyKey } from '@/lib/idempotency'

export const facilitySchema = z.object({
  id: z.string(),
  name: z.string(),
  address_line1: z.string().nullable(),
  address_line2: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  postal_code: z.string().nullable(),
  phone: z.string().nullable(),
  status: z.string(),
})
export type Facility = z.infer<typeof facilitySchema>

export interface CreateFacilityInput {
  name: string
  address_line1?: string
  address_line2?: string
  city?: string
  state?: string
  postal_code?: string
  phone?: string
}

export interface UpdateFacilityInput {
  name?: string
  address_line1?: string
  address_line2?: string
  city?: string
  state?: string
  postal_code?: string
  phone?: string
  status?: 'active' | 'archived'
}

export async function listFacilities(): Promise<Facility[]> {
  const raw = await api.get<unknown[]>('/facilities')
  return raw.map((f) => facilitySchema.parse(f))
}

export async function createFacility(input: CreateFacilityInput): Promise<Facility> {
  const raw = await api.post<unknown>('/facilities', input as unknown as Record<string, unknown>, {
    idempotencyKey: newIdempotencyKey(),
  })
  return facilitySchema.parse(raw)
}

export async function updateFacility(id: string, input: UpdateFacilityInput): Promise<Facility> {
  const raw = await api.patch<unknown>(`/facilities/${id}`, input as unknown as Record<string, unknown>)
  return facilitySchema.parse(raw)
}
